"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "WebcamPreview", {
  enumerable: true,
  get: function get() {
    return _WebcamPreview["default"];
  }
});
var _WebcamPreview = _interopRequireDefault(require("./WebcamPreview"));